import { useTranslation } from "react-i18next";
import { DocumentEditor } from "src/components/editor/DocumentEditor";
import { substituteVariables } from "src/components/editor/adapters/tiptap/substitute";
import type { TDocumentContent, TDocumentVariableKey } from "@shared/entities";

type Props = {
  title: string;
  content: TDocumentContent;
  variableValues: Partial<Record<TDocumentVariableKey, string>>;
};

export function TemplateStepPreview({ title, content, variableValues }: Props) {
  const { t } = useTranslation("doctorTemplates");
  const previewContent = substituteVariables(content, variableValues);

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-lg bg-default-50 px-4 py-2">
        <p className="text-xs font-medium text-default-500 uppercase tracking-wide">
          {t("stepPreviewTitle")}
        </p>
        <p className="mt-1 text-base font-semibold text-default-800">{title}</p>
      </div>
      <DocumentEditor
        content={previewContent}
        readOnly
        variables={[]}
        className="min-h-[300px]"
      />
    </div>
  );
}
